import { getServerSideSitemap } from 'next-sitemap';
import axios from 'axios';
import { getSiteURL } from '@lib/utils';

const PAGESIZE = 10000;

const API_PATH =
  process.env.NEXT_PUBLIC_VERCEL_ENV === 'production'
    ? 'https://api.sibcycline.com/v2'
    : 'https://api-staging.sibcycline.com/v2';

export const getServerSideProps = async (ctx) => {
  const paramsSansExt = ctx.params.slug.replace('.xml', '');
  let [state, county, pageNum] = paramsSansExt.split('_');

  const siteUrl = getSiteURL();
  let listings = [];

  try {
    const skip = !isNaN(pageNum) ? pageNum * PAGESIZE : 0;
    const data = await axios.get(
      `${API_PATH}/sitemaps/listings/${state}/${county}?skip=${skip}&take=${PAGESIZE}`
    );

    const listingEndpoints = data?.data;

    if (!listingEndpoints || listingEndpoints.length < 1) throw new Error('no listings found');

    listings = listingEndpoints.map((item) => {
      return {
        lastmod: item.lastmod,
        loc: siteUrl + item.loc
      };
    });
  } catch (ex) {
    console.error('error in county listing handling:', ex);
    return { notFound: true };
  }

  return getServerSideSitemap(ctx, listings);
};

// Default export to prevent next.js errors
export default function Sitemap() {}
